<template>
  <v-app id="inspire">
    <v-content>
      <v-container
        fluid
        fill-height
      >
        <v-layout
          align-center
          justify-center
        >
          <v-flex
            xs12
            sm8
            md4
          >
            <v-card class="elevation-12">
              <v-toolbar
                dark
                color="primary"
              >
                <v-toolbar-title>{{ verify ? verify.text_verified : '' }}</v-toolbar-title>
                <v-spacer />
              </v-toolbar>
              <v-card-text>
                <v-alert
                  :value="!valid_token"
                  :type="verify ? verify.css_class :''"
                  v-html="verify ? verify.text : ''"
                />
              </v-card-text>
              <!--<v-card-actions >
                                <v-btn @click="$router.push({ name : 'login'})"
                                       color="gray">Iniciar sesión</v-btn>
                                <v-spacer></v-spacer>
                            </v-card-actions>-->
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>
<script>

    export default {
        name: "VerifyEmail",
        data(){
            return {
                message : '',
                valid_token : false,
                loading : false,
                verify : null
            }
        },
        mounted() {
            let meta_json = document.querySelector('meta[name="data-json"');
            if(meta_json){
                let data = JSON.parse(meta_json.getAttribute('content'));
                this.verify = Object.assign({}, data);
            }
        },
        methods : {

        }
    }
</script>

<style scoped>

</style>
